export default "__VITE_ASSET__BlhHGg1q__"